import { render, staticRenderFns } from "./CompanyListPage.vue?vue&type=template&id=c2f61104&"
import script from "./CompanyListPage.vue?vue&type=script&lang=ts&"
export * from "./CompanyListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports